module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integration"
  }, [_c('banner', {
    attrs: {
      "clazz": "integration-banner",
      "url": "integration",
      "hasDivider": ""
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goTrial('kaifangpingtai-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "integration-section1"
  }, [_c('div', {
    staticClass: "section1-content"
  }, [_c('h1', {
    staticClass: "section1-title"
  }, [_vm._v("联合合作伙伴及资源，只为您提供较好业务体验")]), _vm._v(" "), _c('div', {
    staticClass: "section1-divider"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hover-button', {
    attrs: {
      "clazz": "consult-button",
      "text": "申请体验"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTrial('kaifangpingtai-yewu-tiyan')
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "integration-section5"
  }, [_c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("云平台资源，帮他们节省了大量支出")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider dib"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section2-systemlist tl dib"
  }, [_c('span', {
    staticClass: "expand-content dib"
  }, _vm._l((_vm.expandItemList), function(item, index) {
    return _c('div', {
      staticClass: "expandItem tc dib",
      class: index === 0 ? 'expand' : '',
      style: ({
        'backgroundImage': item.kaif_img ? 'url(' + _vm.$global.globalPath + item.kaif_img + ')' : ''
      }),
      on: {
        "mouseenter": function($event) {
          return _vm.listExpandOn(index)
        },
        "mouseleave": _vm.listExpandOff,
        "click": function($event) {
          return _vm.goClientDetail(item.id, item.status)
        },
        "touchstart": function($event) {
          return _vm.listExpandOn(index)
        },
        "touchend": function($event) {
          return _vm.listExpandOn(index)
        }
      }
    }, [_c('div', {
      staticClass: "expandItemMask"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.kaif_logo),
        expression: "$global.globalPath + item.kaif_logo"
      }],
      staticClass: "expandItemIcon",
      attrs: {
        "alt": item.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "expandItemTextContainer"
    }, [_c('p', {
      staticClass: "expandItemText dib textContent"
    }, [_vm._v(_vm._s(index === 0 ? item.kaif_describe : item.title))]), _vm._v(" "), _c('p', {
      staticClass: "expandItemText textFooter tl"
    }, [_vm._v(_vm._s(item.kaif_seo ? '——' + item.kaif_seo : ''))])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "expandItem static tc dib",
    on: {
      "click": _vm.listMove
    }
  }, [_c('img', {
    staticClass: "expandItemIcon",
    attrs: {
      "src": require("../../assets/img/purchaseManage/arrow@2x.png"),
      "alt": "expandItemIcon"
    }
  })])])]), _vm._v(" "), _c('hover-button', {
    attrs: {
      "text": "获取更多案例",
      "clazz": "get-detail dib"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goMoreCase.apply(null, arguments)
      }
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integration-intro"
  }, [_c('p', [_vm._v("开放平台计划，将在采购供应资源、供应商风险舆情管控、电子签章、电子发票等领域中，甄选优质第三方，\n          融合AI、数据挖掘等技术，打造云商业生态圈，为您搭建较好业务实践场景。\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integration-section2"
  }, [_c('div', {
    staticClass: "section2-content"
  }, [_c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("海量资源，互惠共赢")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "integration-intro"
  }, [_c('p', [_vm._v("甄云采购商城，整合多方供应资源，如京东企业购、得力文具、工业品等优质供应货源，一站打通众多电商平台；\n          甄云工具库，整合企业征信、电子签章、OCR识别、电子发票等数字化工具，与甄云SRM无缝融合。\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "section2-con clearfix"
  }, [_c('div', {
    staticClass: "section2-con-content fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/integration/icon1.png"),
      "alt": "垂直行业B2B"
    }
  }), _vm._v(" "), _c('span', [_vm._v("垂直行业B2B")])]), _vm._v(" "), _c('div', {
    staticClass: "section2-con-content fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/integration/icon2.png"),
      "alt": "区域B2B平台"
    }
  }), _vm._v(" "), _c('span', [_vm._v("区域B2B平台")])]), _vm._v(" "), _c('div', {
    staticClass: "section2-con-content fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/integration/icon3.png"),
      "alt": "批发市场"
    }
  }), _vm._v(" "), _c('span', [_vm._v("批发市场")])]), _vm._v(" "), _c('div', {
    staticClass: "section2-con-content fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/integration/icon4.png"),
      "alt": "全球资源"
    }
  }), _vm._v(" "), _c('span', [_vm._v("全球资源")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integration-section3"
  }, [_c('div', {
    staticClass: "section3-content"
  }, [_c('div', {
    staticClass: "section3-title"
  }, [_vm._v("开放平台流程一览图")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "integration-intro"
  }, [_c('p', [_vm._v("采购商场，与电商平台打通，降本增效")])]), _vm._v(" "), _c('div', {
    staticClass: "section3-photo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/integration/tupian.png"),
      "alt": "采购商场"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integration-section4"
  }, [_c('div', {
    staticClass: "section4-content"
  }, [_c('div', {
    staticClass: "section4-title"
  }, [_vm._v("采购甄云采购管理系统，您能得到什么？")]), _vm._v(" "), _c('div', {
    staticClass: "section4-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section4-boxlist"
  }, [_c('div', {
    staticClass: "box first"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/integration/icon1-1.png"),
      "alt": "企业采购集中管理"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("企业采购集中管理")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "hidden-content"
  }, [_vm._v("甄云商城一站式企业采购平台，连接多个第三方...")]), _vm._v(" "), _c('p', {
    staticClass: "full-content"
  }, [_vm._v("甄云商城一站式企业采购平台，连接多个第三方采购平台，企业可实现采购集中化和采购信息化一站式管理")])]), _vm._v(" "), _c('div', {
    staticClass: "tail"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box second"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/integration/icon1-2.png"),
      "alt": "择优采购，节约成本"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("择优采购，节约成本")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "hidden-content"
  }, [_vm._v("甄云商城连接京东、震坤行、工品汇...")]), _vm._v(" "), _c('p', {
    staticClass: "full-content"
  }, [_vm._v("甄云商城连接京东、震坤行、工品汇等优质采购平台，海量供货，快速比价，择优采购，降低采购成本")])]), _vm._v(" "), _c('div', {
    staticClass: "tail"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box third"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/integration/icon1-3.png"),
      "alt": "企业自定义商品货架"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("企业自定义商品货架")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "hidden-content"
  }, [_vm._v("支持企业框架协议物料上架，企业可以形成自己的...")]), _vm._v(" "), _c('p', {
    staticClass: "full-content"
  }, [_vm._v("支持企业框架协议物料商家，企业可以形成自己的“协议商品目录和价格”，方便采购人员或员工根据权限自助查询并申购")])]), _vm._v(" "), _c('div', {
    staticClass: "tail"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box fourth"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/integration/icon1-4.png"),
      "alt": "甄云采购商城"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("甄云采购商城")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "hidden-content"
  }, [_vm._v("甄云商业平台可与企业内部的ERP系统无缝集成，实现...")]), _vm._v(" "), _c('p', {
    staticClass: "full-content"
  }, [_vm._v("甄云商业平台可与企业内部的ERP系统无缝集成，实现企业采购流程信息化的全线上管理，\n              一站式服务平台，提高企业采购效率")])]), _vm._v(" "), _c('div', {
    staticClass: "tail-line"
  }, [_c('div', {
    staticClass: "tail"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e4f529e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/integration.vue
// module id = 575
// module chunks = 12